




































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  CreateGripAnalysisEnablerPayload,
  CreateGripAnalysisStrategyPayload,
  CreateGripEnablerBase,
  GripAnalysisEnabler,
  GripItemType,
  GripEnablerDTO,
  GripEnablerStatus,
  GripItemReloadDTO,
  UpdateGripAnalysisStrategyPayload,
  UpdateGripEnablerBase,
} from '../../../store/types/grip.types';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import EnablerModal from '../Enabler/EnablerModal.vue';
import DeleteModalBox from '../../../components/DeleteModalBox.vue';
import GripAnalysisStrategies from './GripAnalysisStrategies.vue';
import { namespace } from 'vuex-class';
import { showUnsavedChangesDialog } from '@/utils/dialog.util';

const unsavedChangesGuard = namespace('unsavedChangesGuard');

@Component({
  components: {
    BaseLoading,
    EnablerModal,
    DeleteModalBox,
    GripAnalysisStrategies,
  },
})
export default class GripAnalysisEnablers extends Vue {
  @Prop() public projectId!: number;
  @Prop() public isDataCollector!: boolean;
  @Prop() public gripAnalysisId!: number;
  @Prop() public gripAnalysisBarrierId!: number;
  @Prop() public gripAnalysisEnablers!: GripAnalysisEnabler[];
  @Prop() public updatedItem!: GripItemReloadDTO;
  public isGripAnalysisEnablersLoading: boolean = false;
  public showEnablerDraggableBox: boolean = false;
  public itemList: GripAnalysisEnabler[] = [];
  public tempDirtyEnabler: CreateGripEnablerBase = {
    title: '',
    description: '',
    links: [],
    attachments: [],
    gripDomainCategoryId: null,
  };
  public modalKey: number = Math.floor(Math.random() * 999);
  public isModalActive: boolean = false;
  public isNew: boolean = false;
  public gripEnablerDetailsForEdit: GripEnablerDTO | null = null;
  public isMinimized: boolean = false;

  @unsavedChangesGuard.State('userSelectedKeepEditing')
  public userSelectedKeepEditing!: boolean;

  @unsavedChangesGuard.Action('notifyKeepEditingSelected')
  public notifyKeepEditingSelected!: () => void;

  @unsavedChangesGuard.Action('resetKeepEditingFlag')
  public resetKeepEditingFlag!: () => void;

  get editingEnablerId(): number | null {
    return this.isModalActive && !this.isNew && this.gripEnablerDetailsForEdit
      ? this.gripEnablerDetailsForEdit.id
      : null;
  }

  public getUpperCase(value: string): string {
    return value.toUpperCase();
  }

  public updated(): void {
    if (this.updatedItem.item === GripItemType.AnalysisEnabler) {
      const element = document.getElementById(
        this.updatedItem.item + '_' + this.updatedItem.id,
      );
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } else if (this.updatedItem.prevItemId) {
        const prevElement = document.getElementById(
          this.updatedItem.prevItemId as string,
        );
        if (prevElement) {
          prevElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }

    if (this.showEnablerDraggableBox) {
      const element = document.getElementById('contentIdForAddEnablers');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  public handleShowDraggableBox(): void {
    this.showEnablerDraggableBox = true;
  }

  public onDragOver(event: any): void {
    const dragSupported = event.dataTransfer.types.length;
    if (dragSupported) {
      event.dataTransfer.dropEffect = 'copy';
      event.preventDefault();
    }
  }

  public onDrop(event: any, id: string): void {
    event.preventDefault();
    const jsonData = event.dataTransfer.getData('application/json');
    const data = JSON.parse(jsonData);
    if (!data) {
      return;
    }

    const { itemType, ...enablerData } = data;
    if (id === 'enablerDropZone' && itemType === 'enabler') {
      const enablerPayload: CreateGripAnalysisEnablerPayload = {
        ...enablerData,
        gripAnalysisId: this.gripAnalysisId,
        gripAnalysisBarrierId: this.gripAnalysisBarrierId,
      };
      this.$emit('addGripAnalysisEnabler', { enablerPayload, isNew: false });
    }
  }

  private _resetLocalModalState(): void {
    this.isModalActive = false;
    this.isMinimized = false;
    this.gripEnablerDetailsForEdit = null;
    this.isNew = false;
    this.modalKey += 1;
  }

  public openEnablerModal(): void {
    // MODIFICATION START: Update openEnablerModal logic
    this._resetLocalModalState();
    this.isNew = true;
    this.isModalActive = true;
  }

  public handleEdit(enabler: GripAnalysisEnabler): void {
    const {
      gripAnalysisStrategies,
      status,
      createdDate,
      updatedDate,
      ...enablerDetails
    } = enabler;

    this._resetLocalModalState();
    this.gripEnablerDetailsForEdit = enablerDetails as GripEnablerDTO;
    this.isNew = false;
    this.isModalActive = true;
  }

  public async closeEnablerModal(): Promise<void> {
    this._resetLocalModalState();
  }

  public minimizeEnablerModal(): void {
    this.isMinimized = true;
  }

  public restoreEnablerModal(): void {
    this.isMinimized = false;
  }

  public handleEnablerCreate(gripEnabler: CreateGripEnablerBase): void {
    const enablerPayload: CreateGripAnalysisEnablerPayload = {
      ...gripEnabler,
      gripAnalysisId: this.gripAnalysisId,
      gripAnalysisBarrierId: this.gripAnalysisBarrierId,
    };
    this.$emit('addGripAnalysisEnabler', {
      enablerPayload,
      isNew: true,
    });
    this._resetLocalModalState();
    this.showEnablerDraggableBox = false;
  }

  public handleEnablerUpdate(
    gripEnablerUpdateData: UpdateGripEnablerBase & { id: number },
  ): void {
    const { id, ...changesToApply } = gripEnablerUpdateData;
    let actualChangesExist = Object.keys(changesToApply).length > 0;

    if (this.gripEnablerDetailsForEdit) {
      let hasMeaningfulChange = false;
      for (const key in changesToApply) {
        if (changesToApply.hasOwnProperty(key)) {
          if (
            JSON.stringify((this.gripEnablerDetailsForEdit as any)[key]) !==
            JSON.stringify((changesToApply as any)[key])
          ) {
            hasMeaningfulChange = true;
            break;
          }
        }
      }
      actualChangesExist = hasMeaningfulChange;
    }

    if (actualChangesExist) {
      this.$emit('updateGripAnalysisEnabler', {
        ...gripEnablerUpdateData, // Send all data including ID
        gripAnalysisId: this.gripAnalysisId,
        gripAnalysisBarrierId: this.gripAnalysisBarrierId,
      });
      this.$emit('handleUpdatedItemReload', {
        item: GripItemType.AnalysisEnabler,
        id: gripEnablerUpdateData.id,
        prevItemId: this.getPrevItemId(gripEnablerUpdateData.id),
      });
    }
    // Always close modal and notify, regardless of whether an API call was made.
    this._resetLocalModalState();
  }

  public handleDelete(gripAnalysisEnablerId: number): void {
    this.$buefy.modal.open({
      parent: this,
      component: DeleteModalBox,
      hasModalCard: true,
      trapFocus: true,
      props: {
        modalTitle: 'Delete Enabler?',
        modalContent:
          'Are you sure you want to delete this enabler? This action cannot be undone.',
      },
      events: {
        close: () => {
          this.$emit('close');
        },
        confirm: () => {
          this.$emit('deleteGripAnalysisEnabler', gripAnalysisEnablerId);
          this.$emit('handleUpdatedItemReload', {
            item: GripItemType.AnalysisEnabler,
            id: gripAnalysisEnablerId,
            prevItemId: this.getPrevItemId(gripAnalysisEnablerId),
          });
        },
      },
    });
  }

  public getPrevItemId(gripEnablerId: number): string {
    const enablerIndex: number = this.itemList.findIndex(
      (item) => item.id === gripEnablerId,
    );

    return enablerIndex > 0
      ? GripItemType.AnalysisEnabler + '_' + this.itemList[enablerIndex - 1].id
      : GripItemType.AnalysisBarrier + '_' + this.gripAnalysisBarrierId;
  }

  public handleUpdatedItemReload(data: GripItemReloadDTO): void {
    this.$emit('handleUpdatedItemReload', data);
  }

  public handleAddGripAnalysisStrategy(strategyDetails: {
    strategyPayload: CreateGripAnalysisStrategyPayload;
    isNew: boolean;
  }): void {
    this.$emit('addGripAnalysisStrategy', strategyDetails);
  }

  public handleUpdateGripAnalysisStrategy(
    strategyPayload: UpdateGripAnalysisStrategyPayload,
  ): void {
    this.$emit('updateGripAnalysisStrategy', strategyPayload);
  }

  public handleDeleteGripAnalysisStrategy(
    gripAnalysisStrategyId: number,
  ): void {
    this.$emit('deleteGripAnalysisStrategy', gripAnalysisStrategyId);
  }

  @Watch('gripAnalysisEnablers', { deep: true, immediate: true })
  public onGripAnalysisEnablersChanged(
    newEnablers: GripAnalysisEnabler[] | undefined,
  ): void {
    if (newEnablers) {
      // Enablers are already filtered for ACTIVE status by GripAnalysisPane.
      this.itemList = [...newEnablers].sort((a, b) => a.id - b.id);
    } else {
      this.itemList = [];
    }
    // Note: showEnablerDraggableBox is not updated here as its logic
    // seems to be more manually controlled in this component.
  }

  @Watch('userSelectedKeepEditing')
  public onUserSelectedKeepEditing(newValue: boolean): void {
    this.resetKeepEditingFlag();
    if (newValue && this.isMinimized && this.isModalActive) {
      this.restoreEnablerModal();
    }
  }
}
